import { Skeleton } from "@molecules";

// A placeholder shaped like a result cell, for while the results load
export const HaNCellSkeleton = () => {
  return (
    <div className="flex w-full items-center justify-between gap-2">
      <div className="flex items-start gap-3">
        <Skeleton className="size-12 flex-none rounded-lg" />

        <div className="flex flex-col gap-2 pt-1">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      <div className="flex gap-2">
        <Skeleton className="size-5 rounded-full" />
        <Skeleton className="size-5 rounded-full" />
      </div>
    </div>
  );
};
